/**
 * @fileoverview GET handler for the "/engagement/landing_pages/:app_group_id/survey_landing_pages_with_question" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { createTableFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createTableFetcherFunctionWithShadowError";
import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestion } from "./constants";
import type {
  EngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestionParams,
  EngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestionResult,
  EngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestionResultErrors,
} from "./types";
import { isEngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestionResult } from "./validators";

export const getDataTableEngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestion =
  reactQueryTableFetcherAdapter(
    engagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestion,
    createTableFetcherFunctionWithShadowError<EngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestionResultErrors>()(
      (
        signal: AbortSignal,
        {
          appGroupId,
          query = {},
          groupby,
          limit = 20,
          start = 0,
          sortdir,
          sortby,
          questionType,
        }: EngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestionParams
      ): Promise<EngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestionResult> => {
        return fetch(
          `/engagement/landing_pages/${appGroupId}/survey_landing_pages_with_question`,
          "GET",
          {
            groupby,
            limit,
            sortby,
            sortdir,
            start,
            app_group_id: appGroupId,
            question_type: questionType,
            query: serializeQueryObjects(query),
          },
          { signal }
        );
      }
    ),
    isEngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestionResult
  );
